import isNaN from 'lodash.isnan';
import credits from '@/constants/sheet/credits';
import { formatCurrency } from '@/utils/formatCurrency';

export default {
    data: () => ({
        credits
    }),
    computed: {
        maintenanceAmount () {
            let _sum = 0;
            _sum += Number(this.maintenanceExpensesAmount);
            if (this.meetingData.maintenanceExpenses.nurseryCost && this.takeJob === true) {
                _sum += Number(this.meetingData.maintenanceExpenses.nurseryCost) || 0;
            }
            if (this.meetingData.expensesForMedicine.totalMedicineAmount) {
                _sum += Number(this.meetingData.expensesForMedicine.totalMedicineAmount) || 0;
            }
            if (
                this.meetingData.credits.totalAmount &&
        this.meetingData.credits.creditReason !== this.credits.OTHER_CREDIT_REASON &&
        this.meetingData.credits.regularCreditRepair === 'yes'
            ) {
                _sum += Number(this.meetingData.credits.totalAmount) || 0;
            }
            if (
                this.meetingData.credits.informalLiabilityTotalAmount &&
        this.meetingData.credits.informalLiabilityReason !==
          this.credits.OTHER_INFORMAL_LIABILITY_REASON &&
        this.meetingData.credits.informalLiabilityPending === 'yes'
            ) {
                _sum += Number(this.meetingData.credits.informalLiabilityTotalAmount) || 0;
            }
            return formatCurrency(_sum);
        },
        maintenanceExpensesAmount () {
            const { totalAmount = 0, nurseryCost = 0 } = this.meetingData?.maintenanceExpenses ?? {};
            const maintenanceExpensesAmount = this.takeJob ? totalAmount - nurseryCost : totalAmount;
            return formatCurrency(maintenanceExpensesAmount);
        },
        takeJob () {
            return this.meetingData.maintenanceExpenses.takeJob === 'yes';
        },
        receiptsSummary () {
            const { totalReceiptsAmount = 0, totalAnotherReceiptsAmount = 0 } = this.meetingData.cashReceipts ?? {};
            const receiptsSum = Number(totalReceiptsAmount) + Number(totalAnotherReceiptsAmount);
            return formatCurrency(receiptsSum);
        },
        familyReceipt () {
            return Math.round(this.receiptsSummary - this.maintenanceAmount);
        },
        familyReceiptPerMember () {
            const result = Math.round(
                this.familyReceipt / this.meetingData.familyGuide.representatives.length
            );
            return isNaN(result) ? 0 : result;
        }
    }
};
